export default __webpack_public_path__ + "static/KarolWitas-19ca55288ca1df44f66e96e8030a0502.png";